









import { Component, Prop, Vue } from 'vue-property-decorator';
import ProfileService from '@/services/profile/profile.service';

@Component
export default class ProfileLink extends Vue {
	@Prop({ type: String }) username!: string;
	@Prop({ type: String }) user!: string;
	@Prop({ type: Number }) account!: number;

	usernameResult: string | null = null;
	loaded: boolean = true;

	get link() {
	    return this.username ? `/profile/${this.username}` : this.usernameResult ? `/profile/${this.usernameResult}` : null;
	}

	async getUsername() {
	    if (this.username) return;

	    try {
	        if (this.user) {
	            this.usernameResult = await ProfileService.getUsernameByUserId.getUsername(this.user);
	        } else if (this.account) {
	            this.usernameResult = await ProfileService.getUsernameByAccountId.getUsername(this.account);
	        }
	    } finally {
	        this.loaded = true;
	    }
	}

	created() {
	    this.getUsername();
	}
}
